const WhyLRG = () => (
  <section className="section" style={{ background: "var(--lrg-surface)" }} data-testid="why-lrg-section">
    <div className="container-custom">
      <div className="max-w-3xl mx-auto text-center">
        <p className="overline mb-8">Why LRG</p>
        <h2 className="font-editorial text-3xl sm:text-4xl lg:text-5xl font-medium text-[#F2EDE4] leading-[1.15] mb-16">
          Championship coaching. Two locations.<br />A structured pathway. A welcoming culture.
        </h2>
        <div className="divider-thin max-w-24 mx-auto"></div>
      </div>
    </div>
  </section>
);

export default WhyLRG;
